var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1760",
    "data-name": "Group 1760",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M185.665.016c-.027,0-.05-.016-.078-.016H173.923a3.256,3.256,0,0,0-3.255,3.25V4.333a1.085,1.085,0,0,0,2.17,0V3.25a1.086,1.086,0,0,1,1.085-1.083h5.055l-.331.11a2.178,2.178,0,0,0-1.469,2.056v16.25h-3.255a1.086,1.086,0,0,1-1.085-1.083V17.333a1.085,1.085,0,0,0-2.17,0V19.5a3.256,3.256,0,0,0,3.255,3.25h3.255v1.083A2.17,2.17,0,0,0,179.348,26a2.279,2.279,0,0,0,.691-.107l6.519-2.17a2.178,2.178,0,0,0,1.47-2.056V2.167a2.173,2.173,0,0,0-2.363-2.15Zm0,0",
    transform: "translate(-162.028)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M11.617,111.321l-4.34-4.34a1.085,1.085,0,0,0-1.852.767V111H1.085a1.085,1.085,0,0,0,0,2.17h4.34v3.255a1.085,1.085,0,0,0,1.852.767l4.34-4.34a1.083,1.083,0,0,0,0-1.534Zm0,0",
    transform: "translate(0 -101.252)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogin);
export default __webpack_public_path__ + "static/media/dashboardLogin.158c5d7dd452701116f2b7254767a742.svg";
export { ForwardRef as ReactComponent };